/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressDecoder,
  getAddressEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type ReadonlyUint8Array,
} from '@solana/kit';

export type FeeBeneficiary = {
  wallet: Address;
  shareBps: number;
  pad: ReadonlyUint8Array;
};

export type FeeBeneficiaryArgs = FeeBeneficiary;

export function getFeeBeneficiaryEncoder(): FixedSizeEncoder<FeeBeneficiaryArgs> {
  return getStructEncoder([
    ['wallet', getAddressEncoder()],
    ['shareBps', getU16Encoder()],
    ['pad', fixEncoderSize(getBytesEncoder(), 6)],
  ]);
}

export function getFeeBeneficiaryDecoder(): FixedSizeDecoder<FeeBeneficiary> {
  return getStructDecoder([
    ['wallet', getAddressDecoder()],
    ['shareBps', getU16Decoder()],
    ['pad', fixDecoderSize(getBytesDecoder(), 6)],
  ]);
}

export function getFeeBeneficiaryCodec(): FixedSizeCodec<
  FeeBeneficiaryArgs,
  FeeBeneficiary
> {
  return combineCodec(getFeeBeneficiaryEncoder(), getFeeBeneficiaryDecoder());
}
